import React from "react";
import Alert from "react-bootstrap/Alert";
import { useTranslation } from "react-i18next";

function AlertMessage (props) {
    const { i18n } = useTranslation();
    return (
        <Alert show={props.show} variant="danger">
            <Alert.Heading>{i18n.t("alert_validation")}</Alert.Heading>
            <p>{i18n.t("alert_validation_text")}</p>
        </Alert>
    );
}

export default AlertMessage;
